import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const HydraulicPump = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();
  const [folderName, setFolderName] = useState("default");
  const [flowRate, setFlowRate] = useState('');
  const [pressure, setPressure] = useState('');
  const [cylinderBore, setCylinderBore] = useState('');
  const [strokeLength, setStrokeLength] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (!userEmail) {
      navigate("/signin");
    }
  }, [userEmail, navigate]);


 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const params = {
      path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
      folder_path: folderName,
      flowRate: parseFloat(flowRate),
      pressure: parseFloat(pressure),
      cylinderBore: parseFloat(cylinderBore),
      strokeLength: parseFloat(strokeLength),
    };

    try {
      const response = await fetch('https://www.d-rosa.ai/circuitcalculate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
      });
      const data = await response.json();
      setResult(data);
      
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <center>
      <h1 className="text-xl font-bold mb-4">Hydraulic Pump Estimation</h1>
      </center>
      <p>Signed in as: {userEmail}</p>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          
          <input
            type="number"
            value={flowRate}
            onChange={(e) => setFlowRate(e.target.value)}
            placeholder="Flow Rate (L/min)"
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <br /><br />
        <div>
          
          <input
            type="number"
            value={pressure}
            onChange={(e) => setPressure(e.target.value)}
            placeholder="Pressure (Bar)"
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <br /><br />
        <div>
          
          <input
            type="number"
            value={cylinderBore}
            onChange={(e) => setCylinderBore(e.target.value)}
            placeholder="Cylinder Bore (mm)"
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <br /><br />
        <div>
          
          <input
            type="number"
            value={strokeLength}
            onChange={(e) => setStrokeLength(e.target.value)}
            placeholder="Stroke Length (mm)"
            className="w-full p-2 border rounded"
            required
          />
        </div>
        <br /><br />
        <button type="submit" disabled={loading}>
          {loading ? 'Calculating...' : 'Calculate'}
        </button>
      </form>

      {result && (
        <div>
          <h2>Results</h2>
          <p>Pump Size: {result.pumpSize} kW</p>
          <p>Force: {result.force} N</p>
          {/* Add more results as needed */}
        </div>
      )}

      <br /><br />

      

      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>
      <br /><br /><br /><br /><br /><br /><br /><br /><br />

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default HydraulicPump;
